export const SELECT_OPERADOR_SUPERVISOR = 999999;
export const SEARCH_ADMIN = 383;
export const SELECT_OPERADOR = 383;
export const SHOW_OPERADORES = 389;
export const SHOW_ANUNCIO = 392;
export const VER_LISTADO_VENTAS = 513;
